
import React from 'react';
import AccountActivationForm from '@/components/auth/AccountActivationForm';

const AccountActivationPage: React.FC = () => {
  return <AccountActivationForm />;
};

export default AccountActivationPage;
